import { render, staticRenderFns } from "./LinkTemplate.vue?vue&type=template&id=1a47551c&scoped=true"
import script from "./LinkTemplate.vue?vue&type=script&lang=js"
export * from "./LinkTemplate.vue?vue&type=script&lang=js"
import style0 from "./LinkTemplate.vue?vue&type=style&index=0&id=1a47551c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47551c",
  null
  
)

export default component.exports